/*=============================================
=         Table Header Column Styles          =
=============================================*/

@import './pk-table-header-col.variables';

:host {
  @apply flex;
}

:host(.pk-table--header-col) {
  @apply box-border w-full items-center overflow-hidden  px-[--pk-cell--horizontal-pad] py-[--pk-cell--vertical-pad];

  justify-content: var(--pk-cell--justify-content);
  text-align: var(--pk-cell--text-align);

  &.with-width {
    @apply shrink-0 grow-0 basis-[--pk-cell--width,_auto];
  }

  &.is-sortable {
    pk-icon {
      @apply [--icon-width:23px]; // force icon size for alignment
    }

    &:hover {
      @apply cursor-pointer;
    }
  }

  &.can-grow {
    @apply grow;
  }

  &.can-shrink {
    @apply shrink;
  }

  &.is-hidden {
    @apply hidden;
  }
}

.pk-table--header-label {
  @apply select-none overflow-hidden text-ellipsis text-xs leading-m text-text-02;

  &.is-active {
    @apply text-interaction;
  }
}
